var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-header',{attrs:{"title":_vm.title,"items":_vm.items}}),_c('div',{staticClass:"row"},[(_vm.currentContentComponent.key)?_c('div',{staticClass:"col-12"},[_c('edit-content',{attrs:{"current-content-component":_vm.currentContentComponent}})],1):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }